// Lightweight Button component - replaces NextUI Button
import React from 'react';

const Button = ({ 
  children,
  color = 'primary',
  variant = 'solid',
  size = 'md',
  className = '',
  isLoading = false,
  disabled = false,
  ...props 
}) => {
  const baseClasses = "font-semibold rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";
  
  const colorClasses = {
    primary: {
      solid: "bg-[#DC2626] hover:bg-[#B91C1C] text-white focus:ring-[#DC2626]",
      bordered: "border-2 border-[#DC2626] text-[#DC2626] hover:bg-[#DC2626] hover:text-white focus:ring-[#DC2626]",
      light: "bg-red-50 text-[#DC2626] hover:bg-red-100 focus:ring-[#DC2626]",
      flat: "text-[#DC2626] hover:bg-red-50 focus:ring-[#DC2626]"
    },
    default: {
      solid: "bg-gray-600 hover:bg-gray-700 text-white focus:ring-gray-600",
      bordered: "border-2 border-gray-600 text-gray-600 hover:bg-gray-600 hover:text-white focus:ring-gray-600",
      light: "bg-gray-100 text-gray-600 hover:bg-gray-200 focus:ring-gray-600",
      flat: "text-gray-600 hover:bg-gray-100 focus:ring-gray-600"
    }
  };

  const sizeClasses = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-6 py-2.5 text-base",
    lg: "px-8 py-3 text-lg"
  };

  const classes = `${baseClasses} ${colorClasses[color]?.[variant] || colorClasses.primary.solid} ${sizeClasses[size]} ${className}`;

  return (
    <button
      className={classes}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <span className="flex items-center">
          <svg className="animate-spin -ml-1 mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647A7.962 7.962 0 0112 20a7.962 7.962 0 01-5-1.709z"></path>
          </svg>
          Loading...
        </span>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
